import React, { useEffect, useState } from "react";

import { useTable, useSortBy, usePagination, useFilters } from "react-table";
import { useHistory } from "react-router-dom";

import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";
import { BsEye, BsThreeDots } from "react-icons/bs";
import { FiEdit } from "react-icons/fi";

import { BiBlock } from "react-icons/bi";
import {
  MdOutlineDoNotDisturbOn,
  MdSettingsBackupRestore,
} from "react-icons/md";
import { Link as ReactLink } from "react-router-dom";

import {
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Link,
  Text,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  IconButton,
  useDisclosure,
} from "@chakra-ui/react";

import SemRegistros from "../SemRegistros";
import TablePagination from "../TablePagination";
import { isEmptyArray } from "formik";
import { SuspenderModal } from "../../pages/ServicosAcolhimento/Suspender";
import { DesativarModal } from "../../pages/ServicosAcolhimento/Desativar";
import { ReativarModal } from "../../pages/ServicosAcolhimento/Reativar";
import { PrintMenuItem } from "../PrintMenuItem";
import {
  Permission,
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../Context/AuthProvider";

const TableSA = (props) => {
  const { data, columns, entidade, loading } = props;
  const { user } = useAuthProvider();
  const history = useHistory();

  const {
    isOpen: isOpenSuspender,
    onOpen: onOpenSuspender,
    onClose: onCloseSuspender,
  } = useDisclosure();

  const {
    isOpen: isOpenDesativar,
    onOpen: onOpenDesativar,
    onClose: onCloseDesativar,
  } = useDisclosure();

  const {
    isOpen: isOpenReativar,
    onOpen: onOpenReativar,
    onClose: onCloseReativar,
  } = useDisclosure();

  const [nItens, setNItens] = useState(10);
  const [shiftPressed] = useState(false);
  const [ordered, setOrdered] = useState([
    {
      id: "nomeFantasia",
      desc: false,
    },
  ]);
  const [selectedSA, setSelectedSA] = useState();

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    pageOptions,
    page,
    pageCount,
    prepareRow,
    canPreviousPage,
    canNextPage,
    gotoPage,
    rows,
    nextPage,
    previousPage,
    setPageSize,
    state,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        filters: [],
        pageIndex: 0,
        sortBy: sessionStorage.getItem("table-sa")
          ? JSON.parse(sessionStorage.getItem("table-sa")).filter(
              (order) => order.desc !== undefined
            )
          : [
              {
                id: "nomeFantasia",
                desc: false,
              },
            ],
        pageSize: nItens,
      },
    },
    useFilters,
    useSortBy,
    usePagination,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        ...columns,
        {
          id: "options",
          Header: "Opções",
          Cell: ({ row }) => (
            <Flex justifyContent="center">
              <Menu>
                <MenuButton
                  as={IconButton}
                  icon={<BsThreeDots color="#fff" fontSize="20px" />}
                  variant={"link"}
                  cursor={"pointer"}
                  backgroundColor="#95BCBF"
                  color="#fff"
                  rounded={100}
                  p={2}
                />
                <MenuList>
                  <Permission
                    roleKeycloack={props.roleKeycloack}
                    func={servicoAcolhimentoFunc.visualizar}
                  >
                    <Link
                      as={ReactLink}
                      color={"#374BCE"}
                      _hover={{ textDecoration: "none" }}
                      to={"/servico-acolhimento/" + row.original.id}
                    >
                      <MenuItem p={2}>
                        <BsEye />
                        <Text ml="5px">Visualizar</Text>
                      </MenuItem>
                    </Link>
                  </Permission>

                  {props?.roleKeycloack &&
                    (props?.roleKeycloack?.includes(
                      servicoAcolhimentoFunc.editar
                    ) ||
                      ((props?.roleKeycloack?.includes(
                        criancaFunc.visualizarTudoAcolhimento
                      ) ||
                        props?.roleKeycloack?.includes(
                          criancaFunc.visualizarTudoTutelar
                        )) &&
                        user?.orgaoExterno?.includes(
                          Number(row.original.idPessoaJuridica)
                        ))) && (
                      <Link
                        as={ReactLink}
                        color={"#374BCE"}
                        _hover={{ textDecoration: "none" }}
                        to={"/servico-acolhimento/editar/" + row.original.id}
                      >
                        <MenuItem p={2}>
                          <FiEdit />
                          <Text ml="5px">Editar</Text>
                        </MenuItem>
                      </Link>
                    )}

                  <PrintMenuItem idSA={row.original.id} />

                  <Permission
                    roleKeycloack={props.roleKeycloack}
                    func={criancaFunc.visualizarTudo}
                  >
                    {(row.original.suspenso === "N" ||
                      !row.original.suspenso) &&
                      (row.original.desativado === "N" ||
                        !row.original.desativado) && (
                        <MenuItem
                          color={"#374BCE"}
                          p={2}
                          onClick={() => {
                            setSelectedSA(row.original);
                            onOpenSuspender();
                          }}
                        >
                          <MdOutlineDoNotDisturbOn />
                          <Text ml="5px">Suspender</Text>
                        </MenuItem>
                      )}
                    {(row.original.desativado === "N" ||
                      !row.original.desativado) && (
                      <MenuItem
                        color={"red.500"}
                        p={2}
                        onClick={() => {
                          setSelectedSA(row.original);
                          onOpenDesativar();
                        }}
                      >
                        <BiBlock />
                        <Text ml="5px">Desativar</Text>
                      </MenuItem>
                    )}
                    {(row.original.suspenso === "S" ||
                      row.original.desativado === "S") && (
                      <MenuItem
                        color={"green.500"}
                        p={2}
                        onClick={() => {
                          setSelectedSA(row.original);
                          onOpenReativar();
                        }}
                      >
                        <MdSettingsBackupRestore />
                        <Text ml="5px">Reativar</Text>
                      </MenuItem>
                    )}
                  </Permission>
                </MenuList>
              </Menu>
            </Flex>
          ),
        },
      ]);
    }
  );

  useEffect(() => {
    if (sessionStorage.getItem(entidade + "-pagination-count")) {
      setNItens(
        parseInt(sessionStorage.getItem(entidade + "-pagination-count"))
      );
    }
    if (sessionStorage.getItem("table-sa")) {
      setOrdered(
        JSON.parse(sessionStorage.getItem("table-sa")).filter(
          (order) => order.desc !== undefined
        )
      );
    }
  }, [entidade]);

  useEffect(() => {
    if (sessionStorage.getItem(entidade + "-pagination-page")) {
      const tempPage = Number(
        sessionStorage.getItem(entidade + "-pagination-page")
      );
      if (tempPage <= pageCount) {
        gotoPage(tempPage);
      }
    }
  }, [state, entidade, gotoPage, pageCount]);

  function irParaPagina(pagina) {
    sessionStorage.setItem(entidade + "-pagination-page", pagina);
    gotoPage(pagina);
  }

  function selecionarTotalItens(nItens) {
    sessionStorage.setItem(entidade + "-pagination-count", nItens);
    setPageSize(nItens);
  }

  const handleSortingPersistence = (column) => {
    const hasOrdered = ordered.find((order) => order.id === column.id);
    let sortedDesc;
    const tempOrdered = [];

    if (!shiftPressed) {
      sessionStorage.removeItem("tabela-cadastros");
    }

    if (!shiftPressed && ordered.length > 1 && !column.isSortedDesc) {
      sortedDesc = column.isSortedDesc;
    } else {
      switch (column.isSortedDesc) {
        case true:
          sortedDesc = undefined;
          break;
        case false:
          sortedDesc = true;
          break;
        default:
          sortedDesc = false;
          break;
      }
    }

    if (shiftPressed) {
      if (hasOrdered) {
        tempOrdered.push(
          ...ordered.map((order) => {
            if (order.id === column.id) {
              return { id: column.id, desc: sortedDesc };
            } else {
              return order;
            }
          })
        );
        setOrdered(tempOrdered);
      } else {
        tempOrdered.push(...ordered);
        tempOrdered.push({ id: column.id, desc: sortedDesc });
        setOrdered(tempOrdered);
      }
    } else {
      tempOrdered.push({ id: column.id, desc: sortedDesc });
      setOrdered(tempOrdered);
    }

    sessionStorage.setItem("table-sa", JSON.stringify(tempOrdered));
  };

  const handleResetSelected = () => {
    setSelectedSA(null);
  };
  return (
    <Flex flexDir="column" w="100%">
      <Flex flexDir="column" width="100%" mt="20px" h="100%">
        <Flex w={"100%"} flexDir={"column"}>
          {isEmptyArray(data) ? (
            <SemRegistros
              loading={loading}
              entidade={entidade}
              half
              crianca={true}
            />
          ) : (
            <Flex flexDir={"column"}>
              <Flex overflowX="auto" pb={5}>
                <Table {...getTableProps} backgroundColor="white">
                  <Thead backgroundColor="#ECEFF1">
                    {headerGroups.map((headerGroup, index) => (
                      <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                        {headerGroup.headers.map((column, index) => (
                          <Th
                            {...column.getHeaderProps(
                              column.getSortByToggleProps({ title: undefined })
                            )}
                            key={index}
                            p="0px"
                          >
                            <Flex
                              flexDir="row"
                              alignContent="center"
                              px="24px"
                              py="12px"
                              onClick={
                                column.Header !== "Opções"
                                  ? () => {
                                      handleSortingPersistence(column);
                                    }
                                  : null
                              }
                            >
                              <Text as="p">{column.render("Header")}</Text>

                              {column.Header !== "Opções" ? (
                                <Flex pl={1} alignItems="center">
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <Icon as={FaSortDown} boxSize="14px" />
                                    ) : (
                                      <Icon as={FaSortUp} boxSize="14px" />
                                    )
                                  ) : (
                                    <Icon as={FaSort} boxSize="14px" />
                                  )}
                                </Flex>
                              ) : (
                                ""
                              )}
                            </Flex>
                          </Th>
                        ))}
                      </Tr>
                    ))}
                  </Thead>
                  <Tbody {...getTableBodyProps}>
                    {page.map((row, i) => {
                      prepareRow(row);

                      return (
                        <Tr {...row.getRowProps()} key={i}>
                          {row.cells.map((cell, index) => {
                            return (
                              <Td
                                py="6px"
                                fontWeight={400}
                                fontSize="13px"
                                lineHeight="21.6px"
                                {...cell.getCellProps()}
                                key={index}
                              >
                                {cell.render("Cell")}
                              </Td>
                            );
                          })}
                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
              </Flex>

              <TablePagination
                nItens={nItens}
                selecionarTotalItens={selecionarTotalItens}
                irParaPagina={irParaPagina}
                pageSize={state.pageSize}
                setPageSize={setPageSize}
                rows={rows}
                gotoPage={gotoPage}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                pageOptions={pageOptions}
                pageIndex={state.pageIndex}
                canNextPage={canNextPage}
                nextPage={nextPage}
                pageCount={pageCount}
              />
            </Flex>
          )}
        </Flex>
      </Flex>
      {selectedSA && (
        <>
          <SuspenderModal
            isOpen={isOpenSuspender}
            onOpen={onOpenSuspender}
            onClose={() => {
              onCloseSuspender();
              handleResetSelected();
            }}
            id={selectedSA.id}
            handleUpdate={() => {
              handleResetSelected();
              history.push(`/servico-acolhimento`);
            }}
          />
          <DesativarModal
            isOpen={isOpenDesativar}
            onOpen={onOpenDesativar}
            onClose={() => {
              onCloseDesativar();
              handleResetSelected();
            }}
            id={selectedSA.id}
            handleUpdate={() => {
              handleResetSelected();
              history.push(`/servico-acolhimento`);
            }}
          />
          <ReativarModal
            isOpen={isOpenReativar}
            onOpen={onOpenReativar}
            onClose={() => {
              onCloseReativar();
              handleResetSelected();
            }}
            id={selectedSA.id}
            isDesativado={selectedSA.desativado === "S"}
            handleUpdate={() => {
              handleResetSelected();
              history.push(`/servico-acolhimento`);
            }}
          />
        </>
      )}
    </Flex>
  );
};
export default TableSA;
